"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignedReplicaVersionIntent = exports.ReplicaVersionIntentPayload = void 0;
exports.replicaVersionIntentSigningInput = replicaVersionIntentSigningInput;
const zod_1 = require("zod");
const securescale_version_js_1 = require("./securescale-version.js");
const Identifier = zod_1.z.string().min(1).max(128).regex(/\S/);
/** Cached authority cannot outlive the approved 96-hour offline permission window. */
exports.ReplicaVersionIntentPayload = zod_1.z
    .object({
    purpose: zod_1.z.literal('securescale-replica-version-intent-v1'),
    schemaVersion: zod_1.z.literal(1),
    action: zod_1.z.enum(['rollback', 'resume']),
    commandId: zod_1.z.string().uuid(),
    tenantId: zod_1.z.string().uuid(),
    storeId: Identifier,
    resourceId: Identifier,
    sourceVersionId: Identifier,
    targetVersionId: Identifier,
    actorId: Identifier,
    reason: zod_1.z.string().trim().min(1).max(2000),
    revision: zod_1.z.string().regex(/^[1-9]\d*$/),
    issuedAt: zod_1.z.string().datetime(),
    expiresAt: zod_1.z.string().datetime(),
})
    .strict()
    .superRefine((v, ctx) => {
    const lifetime = Date.parse(v.expiresAt) - Date.parse(v.issuedAt);
    if (lifetime <= 0 || lifetime > 96 * 60 * 60 * 1000)
        ctx.addIssue({
            code: 'custom',
            path: ['expiresAt'],
            message: 'Authority lifetime must be positive and at most 96 hours',
        });
    if (v.sourceVersionId === v.targetVersionId)
        ctx.addIssue({
            code: 'custom',
            path: ['targetVersionId'],
            message: 'Version intent must change the active version',
        });
});
exports.SignedReplicaVersionIntent = zod_1.z
    .object({
    kind: zod_1.z.literal('securescale-replica-version-intent-v1'),
    payload: exports.ReplicaVersionIntentPayload,
    kid: Identifier,
    /** Standard base64 of the 64-byte Ed25519 signature. */
    signature: zod_1.z.string().regex(/^[A-Za-z0-9+/]{86}==$/),
})
    .strict();
/** SHA-256 these UTF-8 bytes, then sign the digest with the existing trusted Ed25519 key. */
function replicaVersionIntentSigningInput(intent) {
    return (0, securescale_version_js_1.canonicalSecureScaleJson)({ kind: intent.kind, payload: intent.payload, kid: intent.kid });
}
//# sourceMappingURL=securescale-replica-intent.js.map